webpackJsonp([108],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return floatMenu; });
/**
 * Created by lycheng on 2017/12/4.
 * 浮动导航，默认是右边悬浮，需要改变位置可使用
 * floatMenu.config.position重新赋值
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    $container: $('html,body'),
    checkedClass: 'nav-checked',
    position: {
      top: {
        position: 'absolute',
        top: '600px',
        bottom: 'auto'
      },
      middle: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      },
      bottom: {
        // position: 'fixed',
        // top: '500px',
        // bottom: '0'
      },
      minTop: {
        position: 'fixed',
        top: '550px',
        bottom: 'auto'
      },
      minBottom: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      }
    }
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-service-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
    window.onscroll();
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-service-nav-fall');
      var $navItem = $('.js-service-nav-fall li');
      var targets = [];
      var i = 0;
      var position = floatMenu.config.position;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }

      if (top >= tops[0]) {
        if (top + $navCon.height() + floatMenu.config.top > tops[tops.length - 1]) {
          $navCon.css(position.bottom);
        } else {
          $navCon.css(position.middle);
        }
      } else {
        $navCon.css(position.top);
      }
    }

  }
};


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceQA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serviceTopbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_user__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__ = __webpack_require__(7);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */








function serviceQA() {
  var $serviceQA = $('.service-item-qa');
  // 问答题超过两组时隐藏超出部分
  if ($serviceQA.length) {
    var oLi = $serviceQA.find('li');
    if (oLi.length <= 4) {
      $('.service-qa-more').hide();
    }
    for (var i = 0; i < oLi.length; i++) {
      if (i >= 4) {
        oLi.eq(i).hide();
      }
    }
  }
  // 点击查看更多显示超出部分
  $('.service-qa-more').click(function () {
    var oLi = $serviceQA.find('li');
    oLi.show();
    $(this).hide();
  });
}

function serviceTopbar() {
  var $serviceTopbar = $('.service-topbar');
  if ($serviceTopbar.length) {
    $(window).scroll(function () {
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 450) {
        $('.service-topbar').show();
      } else {
        $('.service-topbar').hide();
      }
    });
  }
}

// 滑动到产品价格
function scrollToPrice() {
  $('html,body').animate({
    scrollTop: $('.service-item-price').offset().top - 100
  }, 1e3);
}

function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    if (serviceKey === 'face' || serviceKey === 'isv' || serviceKey === 'xpush') {
      serviceKey = 'base';
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_0_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.to-price').click(function () {
    scrollToPrice();
  });
  // 滑动到产品价格
  var hash = location.hash;
  if (hash === '#price') {
    scrollToPrice();
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["d" /* getQueryString */])('target') === 'price') {
    scrollToPrice();
  }
}
bindEvent();
Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
if ($('.js-service-nav-fall').length) {
  __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__["a" /* floatMenu */].init();
}



/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_medicalMic_scss__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_medicalMic_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_services_medicalMic_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_user__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__ = __webpack_require__(7);






$(function () {
  Object(__WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__["a" /* serviceQA */])();
  Object(__WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__["b" /* serviceTopbar */])();
  $('#applyNow').click(function () {
    __WEBPACK_IMPORTED_MODULE_4_js_api_user__["b" /* checkLogin */]().then(function (result) {
      if (result.code === 80000) {
        Object(__WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__["b" /* showLoginModal */])();
      } else {
        window.open(__WEBPACK_IMPORTED_MODULE_3_config__["a" /* config */].CONSOLE + 'workorder/commit?category=466c640f562a4fd99abff4c80f152bc7&tid=95e30bd4eb2d46a5979675854672835d&categoryName=\u533B\u7597\u9EA6\u514B\u98CE&tname=\u5546\u52A1\u63A5\u6D3D&title=\u533B\u7597\u9EA6\u514B\u98CE - \u670D\u52A1\u7533\u8BF7&id=medicalMic');
      }
    });
  });
});

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[710]);


// WEBPACK FOOTER //
// js/services/medicalMic.a6ad9c4cd01f3a5a7573.bundle.js